module.exports = __webpack_public_path__ + "static/media/share-desc.52ec6d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-new/share-desc.png
// module id = 668
// module chunks = 0